"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
/*
   This is a component that has the widgets used for A/B testing in TrustPilot. Add to the div below to add another widget.
   A/B Test configurations can be made here: https://businessapp.b2b.trustpilot.com/trustbox-optimizer/instructions
*/
exports.default = (function () {
    var ref = React.useRef(null);
    React.useEffect(function () {
        // If window.Trustpilot is available, then we need to load the TrustBox from our ref because it's been loaded on this page before
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(ref.current, true);
        }
    }, []);
    return (React.createElement("div", { className: 'padding-vertical-5' },
        React.createElement("div", { ref: ref, className: 'trustpilot-widget', "data-locale": 'en-US', "data-template-id": '53aa8807dec7e10d38f59f32', "data-businessunit-id": '5cb62d88a70e15000117adb4', "data-style-height": '150px', "data-style-width": '100%', "data-theme": 'light' },
            React.createElement("a", { href: 'https://www.trustpilot.com/review/hellobello.com', target: '_blank', rel: 'noopener' }, "Trustpilot"))));
});
